import React, { useState } from "react"
const BarcodeForm=(props)=>{
    
    return(
        <React.Fragment>
          

<div className="row">
<div className="container">

<div className="col-12">
     <span className="d-inline-block text-white">  انتخاب بارکد بسته </span>
    <input type="text" className="form-control d-inline-block"   pattern="[0-9]*" inputMode="numeric"  value={props.barcodeInput} ref={props.refinput}  onKeyDown={props.checkBarcodeEnter} onChange={props.changeBarcodeInput} autoFocus />
</div>

<div className="col mt-4">
    <div className="btn btn-block btn-dark" onClick={props.selectBarcode}>انتخاب بارکد </div>
    </div>
    </div>
</div> 
            </React.Fragment>
        )
}
export default BarcodeForm;